import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-1 inline-flex border border-gray-300 rounded bg-white text-base font-medium" }

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'YesNoAnswer',
  props: {
  modelValue: {
    type: Boolean as PropType<boolean | null>,
    default: null
  }
},
  emits: ["update:modelValue", "change"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const setValue = (value: boolean) => {
  if (props.modelValue !== value) {
    emit('update:modelValue', value);
    emit('change', value);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["py-3 px-4 focus:outline-none cursor-pointer", __props.modelValue ? 'bg-primary-500 text-white rounded' : 'text-gray-900 bg-white']),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (setValue(true)))
    }, _toDisplayString(_ctx.$t('platform.common.yes')), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["py-3 px-4 focus:outline-none cursor-pointer", [
        __props.modelValue === false ? 'bg-primary-500 text-white rounded' : 'text-gray-900 bg-white',
        typeof __props.modelValue === 'undefined' && 'border-l border-gray-300'
      ]]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (setValue(false)))
    }, _toDisplayString(_ctx.$t('platform.common.no')), 3)
  ]))
}
}

})